import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
// const querystring = require('querystring');

export default class MyMusic extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
		
// 		let parms = JSON.stringify(querystring.parse(this.props.location.search));
        let	parms = parms.replace('?','');

	
		this.state = {
			userProjectId : JSON.parse(parms).id,
			projectContentList : [],
			contentList : [],
			googleDocs : {
 "kind": "drive#fileList",
 "incompleteSearch": false,
 "files": [
  {
   "kind": "drive#file",
   "id": "1IqVvCioctk_33Am_HUZsKDXvKkbEEQMgs0RlMe-Ow5I",
   "name": "KERA Set List",
   "mimeType": "application/vnd.google-apps.document"
  },
  {
   "kind": "drive#file",
   "id": "107-sS9K8Dvu00d09SxRXo7vlPibgAlgrCtsh6bjHKGY",
   "name": "Onward Product Background",
   "mimeType": "application/vnd.google-apps.document"
  },
  {
   "kind": "drive#file",
   "id": "10Om2eyWWn9pnB4ueGZ280Nd6vzY-0B_4sPjTNP_uHw8",
   "name": "Origo Targets - DRAFT",
   "mimeType": "application/vnd.google-apps.spreadsheet"
  },
  {
   "kind": "drive#file",
   "id": "1UGo8RcbM-jsS3p4plxdifniyQnY4B3DEp7px479Usyo",
   "name": "Origo - Tripcoin Overview",
   "mimeType": "application/vnd.google-apps.document"
  },
  {
   "kind": "drive#file",
   "id": "1bBTTiVKzqOCJk7fsL3VMezPuT8I4HQwXAiYPTwNNNec",
   "name": "Origo Biz Dev Org",
   "mimeType": "application/vnd.google-apps.drawing"
  },
  {
   "kind": "drive#file",
   "id": "12aGdiyK3b1mYC648kJrHvc7HyxuxN1aVwK6lNv0C5jQ",
   "name": "Origo Outbound Sales Plan Outline ",
   "mimeType": "application/vnd.google-apps.document"
  },
  {
   "kind": "drive#file",
   "id": "1btkXotK6MWDQ07VQpFpZ_AHNzAruZ6VI",
   "name": "companies_20131119_1211.csv",
   "mimeType": "text/csv"
  },
  {
   "kind": "drive#file",
   "id": "1InSe7TRdrbFsgpAfVnivJp9QgAG44txsEbVFiJ5YQsk",
   "name": "Origo Outbound Sales Plan Outline ",
   "mimeType": "application/vnd.google-apps.document"
  },
  {
   "kind": "drive#file",
   "id": "1iwTrMYb4QYZ71caM2ghGhcuKDGZTpSbV",
   "name": "InkumsahFTB3567InstallmentAgreement.pdf",
   "mimeType": "application/pdf"
  },
  {
   "kind": "drive#file",
   "id": "1WI7sJc1oEyPp-e0EaGZn11Ygpf25mqCT",
   "name": "IsaacInkumsah",
   "mimeType": "application/vnd.google-apps.folder"
  },
  {
   "kind": "drive#file",
   "id": "1wHC1WfnQy2tUcx3mI1JDwbmYanZjVryJ",
   "name": "ISAAC INKUMSAH 16.pdf",
   "mimeType": "application/pdf"
  },
  {
   "kind": "drive#file",
   "id": "1nHS86rvddqa92ZdS9RvXkm3qK-K5YjKf",
   "name": "ISAAC-INKUMSAH-2015.pdf",
   "mimeType": "application/pdf"
  },
  {
   "kind": "drive#file",
   "id": "1-9UnhlLFay4jrw9ysKJdRIdml0BJ1nCi",
   "name": "ISAAC INKUMSAH 16.pdf",
   "mimeType": "application/pdf"
  },
  {
   "kind": "drive#file",
   "id": "1ClsxvGO5GpLyLy5gEnU18fkEZ_xH6u_M",
   "name": "InkumsahIRS",
   "mimeType": "application/vnd.google-apps.folder"
  },
  {
   "kind": "drive#file",
   "id": "1aFRQ5ShgoD0zVBMA3iZ_J2hpPn7T6glQ",
   "name": "InkumsahLetter.docx",
   "mimeType": "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  },
  {
   "kind": "drive#file",
   "id": "1r7uxvpOHBz5TISILAnMm8kK5wlCcJvPF",
   "name": "f433dInkumsah.pdf",
   "mimeType": "application/pdf"
  },
  {
   "kind": "drive#file",
   "id": "1Dclt88TFsnkkh6qzNidO-cjaQpC_q-hF",
   "name": "IsaacFTB3520POA.pdf",
   "mimeType": "application/pdf"
  },
  {
   "kind": "drive#file",
   "id": "1krjcSENUMwWQ7PYycH89GntxRxHOa5fe",
   "name": "IsaacEDDpowerofattorney.pdf",
   "mimeType": "application/pdf"
  },
  {
   "kind": "drive#file",
   "id": "1UjyCWCJTJgaWMghmg_udnBTv4lSp8G3B",
   "name": "Isaacf2848.pdf",
   "mimeType": "application/pdf"
  },
  {
   "kind": "drive#file",
   "id": "0BxBcCFym52z6d2FOWnZFYzJWYm8",
   "name": "Backroom_Teenies_Blues.MOV",
   "mimeType": "video/quicktime"
  },
  {
   "kind": "drive#file",
   "id": "0BxBcCFym52z6cUc2b1ZiRWNROGc",
   "name": "Backroom_Surrey_With_The_Fringe_On_Top.MOV",
   "mimeType": "video/quicktime"
  },
  {
   "kind": "drive#file",
   "id": "0BxBcCFym52z6UkFoMkJSN1N0RlU",
   "name": "Backroom_Sometime_Ago.MOV",
   "mimeType": "video/quicktime"
  },
  {
   "kind": "drive#file",
   "id": "1_y3fFZfiud8QSRK38AUETVsysu1uaPBgzGK4XWLrOQk",
   "name": "usa-megachurches edits 2016 (2).xlsx",
   "mimeType": "application/vnd.google-apps.spreadsheet"
  },
  {
   "kind": "drive#file",
   "id": "0B68jn5_5qTAdN2kxSjNQdWJaSDg",
   "name": "Voip.rar",
   "mimeType": "application/rar"
  },
  {
   "kind": "drive#file",
   "id": "0B68jn5_5qTAdfk1PRmpRdXA0eS0tXzByY1JKNTVzVVFiZ3RDOXpsUThZY0MxWHRuMFZYM2s",
   "name": "Samples",
   "mimeType": "application/vnd.google-apps.folder"
  },
  {
   "kind": "drive#file",
   "id": "0B68jn5_5qTAdMFQ4TjVELVpjMkk",
   "name": "lookbook.rar",
   "mimeType": "application/rar"
  },
  {
   "kind": "drive#file",
   "id": "0B68jn5_5qTAdWGFzRFZYSC1feWM",
   "name": "Samples.rar",
   "mimeType": "application/rar"
  },
  {
   "kind": "drive#file",
   "id": "0B0ltRunK_GWheUpSZHlzTUV5dkU",
   "name": "LynUp.zip",
   "mimeType": "application/zip"
  },
  {
   "kind": "drive#file",
   "id": "1DA2W_MShVOhErdNk-429vq02MqNMqM1kYLk7bwjGEhg",
   "name": "SaaSPlanSimple",
   "mimeType": "application/vnd.google-apps.spreadsheet"
  },
  {
   "kind": "drive#file",
   "id": "19eBUdvuPSEj1Zq_bbLuLiZSsYlt8u15kx4Q1PQGBWJA",
   "name": "this is my test document baby.",
   "mimeType": "application/vnd.google-apps.document"
  },
  {
   "kind": "drive#file",
   "id": "1W98XDNfNfWpCem7qjL_sLKbssDIg7BaENk-9pJC52fU",
   "name": "Copy of this is my test document baby.",
   "mimeType": "application/vnd.google-apps.document"
  },
  {
   "kind": "drive#file",
   "id": "1LOdV824xv2zxqVEkpepgMnEEwtiq1egBXegkYNvRx8A",
   "name": "Copy of this is my test document baby.",
   "mimeType": "application/vnd.google-apps.document"
  }
 ]
}

		};
		//this.handleDelete = this.handleDelete.bind(this);
	}
	componentDidMount() 
	{
		this.handleOnLoad();
		//this.handleGoogleDocs();
	}

	handleOnLoad = () => {
		const pname = "My Music";
		axios.get(`${global.config.apiServicesUrl}/user-projects?filter[where][ownerUserId][eq]=${this.props.userId}&filter[where][projectName][eq]=${pname}`).then(res => 
		{
			this.setState({userProject : res.data[0]});
  			axios.get(`${global.config.apiServicesUrl}/project-contents?filter[where][userProjectId]=${this.state.userProject.userProjectId}`).then(res => {
				console.log('userproject.content -> ' + res.data);
	 			this.setState({projectContentList : res.data });
				console.log('content objects ' + this.state.projectContentList.length);
				//this.setState({contentList : {}});
				this.state.projectContentList.map(({contentId}) => {
					console.log('getting contented ' + contentId);
						axios.get(`${global.config.apiServicesUrl}/contents/${contentId}`).then(res => {
						this.setState({contentList : [...this.state.contentList, res.data] });
						console.log('content appended ok?');
						console.log(this.state.contentList);
					});			
				});		
			});			
		}).catch(function (error){
			console.log(error);
		});				
	}
	handleGoogleDocs = () => {
		axios.get(`https://www.googleapis.com/drive/v3/files`).then(res => {
			this.setState({googleDocs : res.data});
			console.log(this.state.googleDocs);
		});
	}
	handleChange = (event) => {
		let rid = event.target.value;
		console.log('rid ' + rid);
		axios.get(`${global.config.apiServicesUrl}/user-project?filter[where][UserProjectId]=${event.target.value}`).then(res => {
			const userProjects = res.data;
  			console.log(userProjects);
 			this.setState({ userProjects : userProjects });
			this.setState({ selectedUserProjectId : rid });
		});
	}

	handleDelete = (id, event) => {

		//event.preventDefault();
		//console.log('deleting id - ' + id);
  		//axios.delete(`${global.config.apiServicesUrl}/user-projects/${id}`).then(res => {
		//	const response = res.data;
	  	//	console.log(response);
		//});			
		//window.location.href('/projects');
	}

	render(){
	return (


				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle CORE</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<a href="index.html" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</a>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<a href="index.html" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</a>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="index.html" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
						<div class="m-portlet">
							<div class="m-portlet__body  m-portlet__body--no-padding">
								<div class="row m-row--no-padding m-row--col-separator-xl">
									<div class="col-xl-24">
										<div class="m-widget14">
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															My Music
														</h3>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-brand"></span>
														<input class="form-control input-xlarge col-sm-8" placeholder="Filter" />
													</div>
												</div>

												<div class="row m-row--no-padding align-items-center">


			<table class="table table-bordered table-striped">
			<thead>
	                        <tr>
					<th scope="col">#</th>
					<th scope="col">Document Name</th>
					<th scope="col">Actions</th></tr>
			</thead>
			<tbody>{this.state.contentList.map(({contentId, contentName}) => {
				return <tr>
					<td><Link to={{ pathname: "/content-viewer", search : `?id=${contentId}` }}>{contentId}</Link></td>
					<td><Link to={{ pathname: "/content-viewer", search : `?id=${contentId}` }}>{contentName}</Link></td>
					<td>
						<a href="#"><i class="fa fa-binoculars" onClick={(e) => this.handleDelete(contentId, e) }></i></a>&nbsp;
						<a href="#"><i class="fa fa-edit" onClick={(e) => this.handleDelete(contentId, e) }></i></a>&nbsp;
						<a href="#"><i class="fa fa-check" onClick={(e) => this.handleDelete(contentId, e) }></i></a>&nbsp;
						<a href="#"><i class="fa fa-cross" onClick={(e) => this.handleDelete(contentId, e) }></i></a>&nbsp;
						<a href="#"><i class="fa fa-lock" onClick={(e) => this.handleDelete(contentId, e) }></i></a>&nbsp;
						<a href="#"><i class="fa fa-unlock" onClick={(e) => this.handleDelete(contentId, e) }></i></a>&nbsp;
						<a href="#"><i class="fa fa-trash" onClick={(e) => this.handleDelete(contentId, e) }></i></a>
					</td>
				</tr>
	                        }) 
	                }
	                </tbody>

	                </table>

										</div>

											</div>
										</div>
									</div>


								</div>
							</div>
						</div>            
					</div>		

	            </div>	
            </div>
            
			</div>
			</div>
			


);


}
}

